import { useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useGetCodesQuery } from '@/api/codes/getCodes';

interface Props {
  defaultValue?: string;
  value: string;
  onChange: (e: any) => void;
  label?: string;
  required?: boolean;
}

export const LanguageCodeFormSelect = ({
  defaultValue,
  value,
  onChange,
  label,
  required = false,
}: Props) => {
  // Note: This is a "temporary" solution ;)
  // Use `languageCodes` as `gameCode` to have ability to play with different sports or leagues
  const { data: codes = [] } = useGetCodesQuery();

  const options = useMemo(
    () => codes.map(({ code, name }) => ({ value: code, label: name })) || [],
    [codes]
  );

  return (
    <FormControl sx={{ width: '100%', mt: 2 }} required={required}>
      <InputLabel id='languageCode'>{label}</InputLabel>
      <Select
        id='languageCode'
        label={label}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
